import { memo, useState } from 'react';
import { useDebounce } from 'use-debounce';

import { type BaseStringSelectProps, StringSelect } from '~/components/StringSelect';
import { usePrivateCountriesList } from '~/swr-hooks/filters/usePrivateCountriesList';

type PrivateCountriesSelectProps = {
  boardId: string | undefined;
  libraryId: string | undefined;
} & BaseStringSelectProps;

export const PrivateCountriesSelect = memo(({ boardId, libraryId, ...props }: PrivateCountriesSelectProps) => {
  const [searchValue, setSearchValue] = useState('');

  const [debouncedSearchValue] = useDebounce(searchValue, 200, {
    trailing: true,
  });

  const { data = [], isLoading } = usePrivateCountriesList({
    search: debouncedSearchValue,
    boardId,
    libraryId,
  });

  return (
    <StringSelect
      placeholder="Search for country"
      isLoading={isLoading}
      values={data}
      onInputChange={setSearchValue}
      {...props}
    />
  );
});

PrivateCountriesSelect.displayName = 'PrivateCountriesSelect';
